export enum LocalStorageKeys {
  LOCALE_EDITS = "localeEdits",
}